import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from 'src/app/layouts/default/default.component';
import { DashboardComponent } from './dashboard.component';

const routes: Routes = [
  {
    path: '', component:DefaultComponent, children: [
      { 
        path: '',component:DashboardComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
